import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'pages/Meetings/hooks/useController';

import CustomModal from 'components/atom/CustomModal';
import Button from 'components/atom/Form/Button';
import Text from 'components/atom/Text/styles';

import { Container } from './styles';

interface IModalSuccessInviteProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalSuccessInvite: React.FC<IModalSuccessInviteProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { setPageActive, setTab } = useController();

  const handleNavigation = useCallback(
    (tab: number) => {
      setPageActive('schedule');
      setTab(tab);
    },
    [setPageActive, setTab],
  );

  return (
    <CustomModal
      isOpen={isOpen}
      title={t('meetings:preview.titleModal')}
      onClose={() => onClose}
      isCentered
      hasCloseButton={false}
    >
      <Container>
        <FontAwesomeIcon icon={faCircleCheck} />

        <Text lineHeight={20} textAlign="center" padding="0 .6rem">
          {t('meetings:preview.modalInfo')}
        </Text>

        <Button
          theme="blue03"
          text={t('meetings:actions.viewInvites')}
          disabledUppercase
          onClick={() => handleNavigation(1)}
        />

        <Button
          theme="light-bordered"
          text={t('meetings:actions.backContacts')}
          disabledUppercase
          onClick={() => handleNavigation(2)}
        />
      </Container>
    </CustomModal>
  );
};

export default ModalSuccessInvite;
